import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'

import Icon from './Icon'
import TextLink from './TextLink'

import cloudinaryTransform from '~helpers/cloudinary'

const ActionCard = ({ hover, photoStretch, photo, url, children, ...opts }) => {
  const theme = useTheme()

  return (
    <TextLink
      href={url}
      css={[
        {
          display: 'inline-flex',
          width: '100%',
          flexDirection: 'column',
          boxShadow: theme.boxShadow.large,
          borderRadius: theme.borderRadius.base,
        },

        hover && {
          position: 'relative',
          transition: `transform ${theme.timing.base} ${theme.transition.bounce}`,
          transformOrigin: 'center center',

          '&:hover, &:focus': {
            transform: 'scale(1.05)',

            '.G__ActionCard__Arrow': {
              transform: 'translateX(0) scale(1)',
              opacity: 1,
            },
          },
        },
      ]}
      {...opts}
    >
      {photo && (
        <div
          css={{
            backgroundColor: theme.color.dark.base,
            backgroundSize: photoStretch || '50% auto',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            height: 140,
            borderTopLeftRadius: theme.borderRadius.base,
            borderTopRightRadius: theme.borderRadius.base,
          }}
          className="G__ActionCard__Photo"
          style={{ backgroundImage: `url(${cloudinaryTransform(photo)})` }}
        />
      )}
      <div
        css={{
          flex: 1,
          padding: theme.space.medium,
          fontWeight: theme.fontWeight.bold,
          color: theme.fontColor.base,
          background: theme.color.light.base,
          borderTopLeftRadius: !photo && theme.borderRadius.base,
          borderTopRightRadius: !photo && theme.borderRadius.base,
          borderBottomLeftRadius: theme.borderRadius.base,
          borderBottomRightRadius: theme.borderRadius.base,
          lineHeight: theme.lineHeight.small,
          border: !photo && theme.border.base,
          position: 'relative',
        }}
        className="G__ActionCard__Content"
      >
        {children}
        {hover && (
          <Icon
            css={{
              position: 'absolute',
              top: 'auto', // Reset from `<Icon />` defaults
              bottom: theme.space.small,
              right: theme.space.small,
              color: theme.color.primary.base,
              opacity: 0,
              transition: `transform ${theme.timing.base} ${theme.transition.bounce}, opacity ${theme.timing.base} ${theme.transition.bounce}`,
            }}
            icon="arrow-right"
            className="G__ActionCard__Arrow"
          />
        )}
      </div>
    </TextLink>
  )
}

ActionCard.propTypes = {
  hover: PropTypes.bool,
  photoStretch: PropTypes.oneOf(['contain', 'cover']),
  photo: PropTypes.string,
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default ActionCard
